import { NotImplementedView } from "~/src/views/fragments/not-implemented";

export const ChangePasswordView = () => {
  return <NotImplementedView />;
};
